import { useState } from 'react'
import Modal from '..'
import ModalClose from '../ModalClose'
import CodeFormModal from './CodeFormModal'
import { IQrCodeModal } from '../../../interfaces/staff'

export const QrCodeModal = ({
  open,
  setIsOpen,
  loading,
  setIsloading,
  qrCodeUrl,
  setIsToggled,
}: IQrCodeModal) => {
  const [isCodeModalOpen, setIsCodeModalOpen] = useState<boolean>(false)

  const closeQrCodeModal = () => {
    setIsCodeModalOpen(false)
    setIsOpen(false)
  }

  const handleEnterCodeClick = () => {
    setIsCodeModalOpen(true)
  }

  return (
    <>
      <Modal
        open={open}
        close={() => setIsOpen(false)}
        modalClassName="p-5 flex flex-col"
      >
        <ModalClose onClick={() => setIsOpen(false)} />
        <div>
          <div className="text-center mb-6">
            <h2 className="text-xl font-semibold mb-4">Scan QR Code</h2>
            {loading ? (
              'Please wait... '
            ) : qrCodeUrl ? (
              <img src={qrCodeUrl} alt="QR Code" className="mx-auto w-32 h-32" />
            ) : (
              <p className="text-red-500">QR Code not available</p>
            )}
          </div>
          <div className="text-center mb-4">
            <p className="text-gray-600">
              Open Google Authenticator app
              <br />
              Tap <strong>‘+’</strong> to scan QR code
              <br />
              Scan the code above
            </p>
          </div>
          <div className="text-center mb-4">
            <p className="font-semibold text-gray-700">OR</p>
            <p className="font-medium text-black mt-2">
              <button
                type="button"
                className="mt-4 text-blue-600 underline cursor-pointer bg-transparent border-none"
                onClick={handleEnterCodeClick}
              >
                Enter code
              </button>
            </p>
          </div>
        </div>
      </Modal>
      {isCodeModalOpen && (
        <CodeFormModal
          open={isCodeModalOpen}
          setIsOpen={setIsCodeModalOpen}
          loading={loading}
          setIsloading={setIsloading}
          onSuccess={closeQrCodeModal}
          setIsToggled={setIsToggled}
        />
      )}
    </>
  )
}
